import PropTypes from 'prop-types';

const DangerIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4245 0.63904C13.8337 0.229869 14.3886 0 14.9673 0H33.0327C33.6114 0 34.1663 0.229869 34.5755 0.63904L47.361 13.4245C47.7701 13.8337 48 14.3886 48 14.9673V33.0327C48 33.6114 47.7701 34.1663 47.361 34.5755L34.5755 47.361C34.1663 47.7701 33.6114 48 33.0327 48H14.9673C14.3886 48 13.8337 47.7701 13.4245 47.361L0.63904 34.5755C0.229869 34.1663 0 33.6114 0 33.0327V14.9673C0 14.3886 0.229869 13.8337 0.63904 13.4245L13.4245 0.63904ZM15.871 4.36364L4.36364 15.871V32.129L15.871 43.6364H32.129L43.6364 32.129V15.871L32.129 4.36364H15.871Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 13.0909C25.205 13.0909 26.1818 14.0677 26.1818 15.2727V24C26.1818 25.205 25.205 26.1818 24 26.1818C22.795 26.1818 21.8182 25.205 21.8182 24V15.2727C21.8182 14.0677 22.795 13.0909 24 13.0909Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8182 32.7273C21.8182 31.5223 22.795 30.5455 24 30.5455H24.0218C25.2268 30.5455 26.2036 31.5223 26.2036 32.7273C26.2036 33.9323 25.2268 34.9091 24.0218 34.9091H24C22.795 34.9091 21.8182 33.9323 21.8182 32.7273Z"
        fill={fill}
      />
    </svg>
  </div>
);

DangerIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

DangerIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default DangerIcon;
